const ResetPasswordValidationMessages = {
    'required.phone': 'Unesi broj telefona.',
    'required.password': 'Unesu lozinku.',
    'min.password': 'Lozinka mora sadržati minimalno 8 karaktera.',
    'confirmed.password': 'Upisane lozinke se ne poklapaju.',
    'required.confimation_password': 'Ponovi lozinku'
};

export default ResetPasswordValidationMessages;